var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _g, _circle57, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgsettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 137,
    viewBox: "0 0 1020 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1019,
    height: 137,
    fill: "#F7F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.83 86.8718L214.881 59.7924L357.048 16.9167L218.83 86.8718Z",
    fill: "#4E82BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.266 87.4358L229.549 67.1262L249.294 71.6395L218.266 87.4358Z",
    fill: "#82ABD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.401 88.0001L228.985 67.1264L358.741 16.3525L285.401 88.0001Z",
    fill: "#96B9E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.881 60.3565L152.26 38.3545L358.74 16.3525L214.881 60.3565Z",
    fill: "#96B9E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M527.95 82.2586C527.95 82.2586 524.968 82.4643 523.425 77.9387C527.539 76.3959 530.522 72.4874 530.522 67.7561C530.522 61.7905 525.688 56.9563 519.722 56.9563H508.819C505.528 56.9563 502.751 59.6305 502.751 63.0247V71.8702V78.6587V85.8585C502.751 87.607 504.088 88.9442 505.837 88.9442C507.585 88.9442 508.922 87.607 508.922 85.8585V78.6587H517.151C519.311 86.3728 524.659 88.4299 527.848 88.4299C528.053 88.4299 528.259 88.4299 528.465 88.4299C530.11 88.327 531.447 86.7842 531.242 85.1385C531.036 83.4928 529.699 82.1557 527.95 82.2586ZM508.922 71.9731V63.2304H519.722C522.293 63.2304 524.35 65.2875 524.35 67.8589C524.35 70.4303 522.293 72.4874 519.722 72.4874H508.922V71.9731Z",
    fill: "#386BA6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.656 55C363.485 55 357.519 57.3657 352.994 61.5827C351.759 62.7141 351.657 64.6684 352.788 65.9026C353.919 67.1369 355.874 67.2397 357.108 66.1083C359.782 63.6398 363.074 62.097 366.571 61.4799V85.8564C366.571 87.605 367.908 88.9421 369.656 88.9421C371.405 88.9421 372.742 87.605 372.742 85.8564V61.4799C376.239 62.097 379.53 63.6398 382.205 66.1083C382.822 66.6226 383.542 66.9312 384.262 66.9312C385.084 66.9312 385.907 66.6226 386.524 65.9026C387.656 64.6684 387.656 62.7141 386.319 61.5827C381.896 57.3657 375.93 55 369.656 55Z",
    fill: "#386BA6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M443.505 55C437.334 55 431.368 57.3657 426.842 61.5827C425.608 62.7141 425.505 64.6684 426.637 65.9026C427.768 67.1369 429.722 67.2397 430.957 66.1083C433.631 63.6398 436.922 62.097 440.419 61.4799V85.8564C440.419 87.605 441.756 88.9421 443.505 88.9421C445.253 88.9421 446.591 87.605 446.591 85.8564V61.4799C450.088 62.097 453.379 63.6398 456.053 66.1083C456.67 66.6226 457.39 66.9312 458.11 66.9312C458.933 66.9312 459.756 66.6226 460.373 65.9026C461.504 64.6684 461.504 62.7141 460.167 61.5827C455.745 57.3657 449.779 55 443.505 55Z",
    fill: "#386BA6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M416.868 57.0562C415.119 57.0562 413.782 58.3933 413.782 60.1418V75.6729C413.782 79.0671 410.593 81.7413 406.582 81.7413C402.571 81.7413 399.382 79.0671 399.382 75.6729V60.1418C399.382 58.3933 398.045 57.0562 396.297 57.0562C394.548 57.0562 393.211 58.3933 393.211 60.1418V75.6729C393.211 82.4613 399.177 87.9126 406.582 87.9126C413.988 87.9126 419.953 82.4613 419.953 75.6729V60.1418C419.953 58.4961 418.616 57.0562 416.868 57.0562Z",
    fill: "#386BA6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M480.43 57.0562C471.893 57.0562 465.002 63.9474 465.002 72.4844C465.002 81.0213 471.893 87.9126 480.43 87.9126C488.967 87.9126 495.858 81.0213 495.858 72.4844C495.858 63.9474 488.967 57.0562 480.43 57.0562ZM480.43 81.7413C475.287 81.7413 471.173 77.6271 471.173 72.4844C471.173 67.3416 475.287 63.2274 480.43 63.2274C485.573 63.2274 489.687 67.3416 489.687 72.4844C489.687 77.6271 485.573 81.7413 480.43 81.7413Z",
    fill: "#386BA6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M542.761 57.0562C541.013 57.0562 539.676 58.3933 539.676 60.1418V84.827C539.676 86.5755 541.013 87.9126 542.761 87.9126C544.51 87.9126 545.847 86.5755 545.847 84.827V60.1418C545.847 58.4961 544.51 57.0562 542.761 57.0562Z",
    fill: "#386BA6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M586.885 84.4173L574.234 60.1435C573.514 58.8064 572.279 58.0864 570.737 58.0864C569.194 58.0864 567.959 58.9093 567.239 60.1435L554.588 84.4173C553.765 85.9601 554.383 87.8115 555.925 88.6343C557.468 89.4572 559.32 88.84 560.142 87.2972L562.508 82.7716C564.668 80.4059 567.651 79.0688 570.839 79.0688C574.028 79.0688 577.011 80.4059 579.171 82.7716L581.536 87.2972C582.051 88.3257 583.182 88.9429 584.313 88.9429C584.828 88.9429 585.239 88.84 585.753 88.6343C587.09 87.8115 587.605 85.9601 586.885 84.4173ZM570.737 72.8975C569.605 72.8975 568.474 73.0004 567.445 73.2061L570.737 66.8291L574.028 73.2061C572.999 73.0004 571.868 72.8975 570.737 72.8975Z",
    fill: "#386BA6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218 84C209.02 93.6483 195.673 99.5354 170.129 95.4004C138.199 90.2316 77.8316 46.814 1 59.219",
    stroke: "#386BA6",
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M846.868 1.22635C809.658 70.2036 927.647 89.0803 928.309 71.9819C929.137 50.6089 902.59 57.9767 904.572 67.1654C906.554 76.3541 921.413 100.555 952.22 95.5401C978.83 91.2083 978.486 89.9071 980.112 85.1035",
    stroke: "#386BA6",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M966.646 96.4492L967.327 88.3361L1011.41 85.4969L966.646 96.4492Z",
    fill: "#4E82BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M966.444 96.5746L971.083 91.4502L976.5 94.0892L966.444 96.5746Z",
    fill: "#82ABD9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M985.86 101.265L970.92 91.4124L1011.94 85.4477L985.86 101.265Z",
    fill: "#96B9E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M967.288 88.4995L950.626 77.902L1011.94 85.4475L967.288 88.4995Z",
    fill: "#96B9E0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 49.5002,
    r: 24.5,
    fill: "#A4A4EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 830.5,
    cy: 97.5002,
    r: 24.5,
    fill: "#A4A4EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_436_4876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 710,
    y: 5,
    width: 82,
    height: 72
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.438,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.146,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.854,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 776.562,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.792,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 745.5,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.208,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 9.43774,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 19.792,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 30.146,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 40.5002,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 50.8545,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 61.2085,
    r: 4.4375,
    fill: "#6B6BDA"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.917,
    cy: 71.5627,
    r: 4.4375,
    fill: "#6B6BDA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_436_4876)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 747.719,
    cy: 41.2398,
    r: 36.2396,
    fill: "#386BA6"
  }))), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.5,
    cy: 48.5002,
    r: 7.5,
    fill: "#A4A4EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 57.0002C34 57.0002 60.7 57.7002 67.5 60.5002",
    stroke: "white",
    strokeDasharray: "4 4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M631 76.1657L633.468 67.0002L666.252 87.0938L665.194 95.9067L662.374 97.6693L666.252 102.605L664.137 112.123L658.496 116L650.741 105.777L641.576 111.065L631 76.1657Z",
    fill: "#386BA6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M644.043 100.842L633.82 67.7053L667.31 87.0938L658.849 93.0866L666.252 102.957L661.317 106.482L652.856 95.9068L644.043 100.842Z",
    fill: "#387CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgsettings);
export default __webpack_public_path__ + "static/media/bgsettings.d59fe772ca6a8e4f85f94f372201aeae.svg";
export { ForwardRef as ReactComponent };